import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { checkIsLoggedIn } from '~/redux/actions/authentication-actions';

class IsAuthenticated extends PureComponent {
	// componentDidMount() {
	// 	// Checks if the user is authenticated
	// 	// This will also update the Redux store if there is an active session
	// 	this.props.dispatch(checkIsLoggedIn());
	// }

	render() {
		const { isTrue, isFalse } = this.props;
		let IsAuthenticated = this.props.isLoggedIn;

		if (IsAuthenticated === true) {
			return <React.Fragment>{isTrue}</React.Fragment>;
		} else {
			return <React.Fragment>{isFalse}</React.Fragment>;
		}
	}
}

// PropTypes
IsAuthenticated.defaultProps = {
	isLoggedIn: false,
};

IsAuthenticated.propTypes = {
	isLoggedIn: PropTypes.bool,
	isTrue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	isFalse: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

function mapStateToProps(state) {
	return {
		isLoggedIn: state.authentication.isLoggedIn,
	};
}

export default connect(mapStateToProps)(IsAuthenticated);



// WEBPACK FOOTER //
// ./src/components/general/restricted/is-authenticated/index.jsx